






















import { Component, Vue, Watch } from "vue-property-decorator";
import zoneBanner from "./components/zoneBanner.vue";
import competitionCalendar from "../components/competitionCalendar/index.vue";
import eventOverview from "./components/eventOverview.vue";
import eventMessage from "./components/eventMessage.vue";
import { matchAreaGame, matchAreaBackground } from "@/req/competitionEvent";
@Component({
  components: {
    zoneBanner,
    competitionCalendar,
    eventOverview,
    eventMessage,
  },
})
export default class Home extends Vue {
  public zoneId = Number(localStorage.getItem("competitionZoneId"));
  public isShow = false;
  public gameId = 0;
  public zoneBgTop = "";
  public zoneBgBot = "";

  @Watch("$route", { deep: true })
  public zoneIdChange(e) {
    if (this.zoneId != e.query.zoneId) {
      this.zoneId = Number(e.query.zoneId);
      this.$forceUpdate();
    }
    this.getMatchAreaBackground();
    this.getGameId();
  }

  public mounted() {
    this.getMatchAreaBackground();
    this.getGameId();
  }

  public async getMatchAreaBackground() {
    const res = await matchAreaBackground({
      area_id: this.zoneId,
    });
    if (res.code == 200) {
      this.zoneBgTop = res.data.background_one;
      this.zoneBgBot = res.data.background_two;
    }
  }

  public async getGameId() {
    // 赛事专区_登录游戏参赛按钮埋点
    // this.$fn.competitionRecord("saishizhuanqu", "saishizhuanqu_8");
    const res = await matchAreaGame({
      token: this.$fn.cookies.getToken(),
      area_id: this.zoneId,
    });
    if (res.code == 200) {
      this.gameId = res.data;
      if (res.data !== 0) {
        this.isShow = true;
      } else {
        this.isShow = false;
      }
    }
  }

  public async toTake() {
    this.$router.push("/");
    return;
  }
}
